import { render, staticRenderFns } from "./turnoverGenerated.vue?vue&type=template&id=2497984a&scoped=true"
import script from "./turnoverGenerated.vue?vue&type=script&lang=js"
export * from "./turnoverGenerated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497984a",
  null
  
)

export default component.exports